import { render, staticRenderFns } from "./AppointmentProcedureList.vue?vue&type=template&id=28d4b92f&scoped=true&"
import script from "./AppointmentProcedureList.vue?vue&type=script&lang=js&"
export * from "./AppointmentProcedureList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d4b92f",
  null
  
)

export default component.exports